import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Registration Complete',
  intlKey: 'pageTitle.registration_complete'
})
class AssessorSuccess extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <h1 className="beta">
            <span
              className="ico ico--checked"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.your_registration_is_complete"
              defaultMessage="Your registration is complete"
            />
          </h1>
          <p className="desc">
            <FormattedMessage
              id="label.we_will_send_you_an_email"
              defaultMessage="We will send you an email when your ORB account registration is approved."
            />
          </p>
        </div>
      </div>
    )
  }
}

export default AssessorSuccess
